
import React from "react";

interface FeatureCardProps {
  title: React.ReactNode;
  description: string;
  icon?: React.ReactNode;
  imageSrc?: string;
  imageAlt?: string;
  imageTitle?: string;
  reverse?: boolean;
  className?: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({
  title,
  description,
  icon,
  imageSrc,
  imageAlt = "Feature illustration",
  imageTitle,
  reverse = false,
  className = "",
}) => {
  return (
    <div className={`flex flex-col ${reverse ? 'md:flex-row-reverse' : 'md:flex-row'} gap-8 items-center mb-16 ${className}`}>
      <div className="w-full md:w-1/2">
        {imageSrc && (
          <img
            src={imageSrc}
            alt={imageAlt}
            title={imageTitle || imageAlt}
            loading="lazy"
            width="600"
            height="400"
            className="rounded-2xl shadow-lg w-full h-auto object-cover"
          />
        )}
        {icon && <div className="text-4xl text-center">{icon}</div>}
      </div>
      <div className="w-full md:w-1/2">
        <h3 className="text-2xl md:text-3xl font-bold mb-4">{title}</h3>
        <p className="text-gray-700">{description}</p>
      </div>
    </div>
  );
};

export default FeatureCard;
